import { Controller } from "@hotwired/stimulus";

export class CertificationModalController extends Controller {
  static targets = [
    "form",
    "modal",
    "title",
    "emmiter",
    "emmitedMonth",
    "emmitedYear",
    "credentialId",
    "credentialUrl",
  ];

  static values = {
    id: String,
    title: String,
    emmiter: String,
    emmitedMonth: String,
    emmitedYear: String,
    credentialId: String,
    credentialUrl: String,
  };

  connect() {
    this.formTarget.action = `/users/edit-certification/${this.idValue}`;
  }

  open(event) {
    this.titleTarget.value = this.titleValue;
    this.emmiterTarget.value = this.emmiterValue;
    this.emmitedMonthTarget.value = this.emmitedMonthValue;
    this.emmitedYearTarget.value = this.emmitedYearValue;
    this.credentialIdTarget.value = this.credentialIdValue;
    this.credentialUrlTarget.value = this.credentialUrlValue;

    this.modalTarget.showModal();
  }

  close(event) {
    this.modalTarget.close();
  }

  submit(event) {
    event.preventDefault();
    if (!this.formTarget.checkValidity()) {
      this.formTarget.reportValidity();
      return;
    } else {
      this.formTarget.requestSubmit();
      return;
    }
  }
}
